import { createApi } from '@reduxjs/toolkit/query/react'
import { baseApi } from './utils'
import { FineManagerDashboardFetch, FineManagerIndexFetch, FineManagerSearchOptionsFetch } from '../../components/FineManager/types'

const endDate = new Date()
const startDate = new Date()
startDate.setFullYear(startDate.getFullYear() - 2)

const historicStartDate = new Date('01/01/1990')
const historicEndDate = new Date()
historicEndDate.setFullYear(historicEndDate.getFullYear() - 2)
historicEndDate.setDate(historicEndDate.getDate() - 1)

export const fineManagerApi = createApi({
	reducerPath: 'fineManager',
	...baseApi('/fine-manager/'),
	refetchOnMountOrArgChange: true,
	tagTypes: ['OpenIndex'],
	endpoints: builder => ({
		getDashboard: builder.query<FineManagerDashboardFetch, void>({
			query: () => 'dashboard.php',
		}),
		getNewIndex: builder.query<FineManagerIndexFetch, void>({
			query: () =>
				'index.php?status=new&startDate=' +
				startDate.toLocaleDateString('en-GB') +
				'&endDate=' +
				endDate.toLocaleDateString('en-GB'),
		}),
		getOpenIndex: builder.query<FineManagerIndexFetch, void>({
			query: () =>
				'index.php?status=open&startDate=' +
				startDate.toLocaleDateString('en-GB') +
				'&endDate=' +
				endDate.toLocaleDateString('en-GB'),
			providesTags: ['OpenIndex'],
		}),
		getOpenToOperatorIndex: builder.query<FineManagerIndexFetch, void>({
			query: () =>
				'index.php?status=open to operator&startDate=' +
				startDate.toLocaleDateString('en-GB') +
				'&endDate=' +
				endDate.toLocaleDateString('en-GB'),
		}),
		getHistoricIndex: builder.query({
			query({ dashType }) {
				return `index.php?status=new,open${dashType == 'oui' ? ',open to operator' : ''}
				&startDate=${historicStartDate.toLocaleDateString('en-GB')}&endDate=${historicEndDate.toLocaleDateString('en-GB')}`
			},
		}),
		getParkingIndex: builder.query({
			query: () =>
				'index.php?type=Parking&startDate=' +
				startDate.toLocaleDateString('en-GB') +
				'&endDate=' +
				endDate.toLocaleDateString('en-GB'),
		}),
		getSpeedingIndex: builder.query({
			query: () =>
				'index.php?type=Speeding&startDate=' +
				startDate.toLocaleDateString('en-GB') +
				'&endDate=' +
				endDate.toLocaleDateString('en-GB'),
		}),
		getAllIndex: builder.query({
			query: () =>
				'index.php?type=Congestion Charge,Traffic Violation,Fine,Bus Lane,Dart Charge,Other,Toll Charge&startDate=' +
				startDate.toLocaleDateString('en-GB') +
				'&endDate=' +
				endDate.toLocaleDateString('en-GB'),
		}),
		getSearchOptions: builder.query<FineManagerSearchOptionsFetch, void>({
			query: () => 'search.php',
		}),
		getSearchIndex: builder.query({
			query: ({ signal, query }) => ({
				url: `index.php?${query}`,
				signal,
			}),
		}),
		updateFines: builder.mutation({
			query(fines) {
				const fineIds = fines.join(':')
				const submitFinesToClose = true
				return {
					url: 'close-fines.php',
					method: 'POST',
					body: { fineIds, submitFinesToClose },
				}
			},
			invalidatesTags: ['OpenIndex'],
		}),
	}),
})

export const {
	useGetDashboardQuery,
	useGetNewIndexQuery,
	useGetOpenIndexQuery,
	useGetOpenToOperatorIndexQuery,
	useGetHistoricIndexQuery,
	useGetParkingIndexQuery,
	useGetSpeedingIndexQuery,
	useGetAllIndexQuery,
	useGetSearchOptionsQuery,
	useGetSearchIndexQuery,
	useUpdateFinesMutation,
} = fineManagerApi
